import React from 'react';
import useLeadReportService from 'domain/sales/report/useLeadReportService';
import { DataGridLayout, DESC, List, ListHeader, ListPageLayout } from 'framework/list';
import RequestLeadReportButton from 'domain/sales/report/List/button/RequestLeadReportButton';
import LeadReportLinkField from 'domain/sales/report/List/field/LeadReportLinkField';
import { DateField } from 'framework/ui/field';
import { DATE_FORMAT } from 'framework/utils';
import { EmployeeLinkFieldWithNameLoading } from 'domain/shared/employee';

const LeadReportsListPage = () => {
  const { search } = useLeadReportService();
  return (
    <List getDataMethod={search} defaultSortField="generatedAt" defaultSortOrder={DESC}>
      <ListPageLayout
        header={<ListHeader label="Lead Reports" icon="fa-users" />}
        actions={[<RequestLeadReportButton />]}
      >
        <DataGridLayout rowKeySource="alias">
          <LeadReportLinkField label="Report type" width={150} />
          <DateField source="periodFrom" label="Period from" />
          <DateField source="periodTo" label="Period to" />
          <DateField source="generatedAt" label="Date of report generation" dateFormat={DATE_FORMAT.FULL} />
          <EmployeeLinkFieldWithNameLoading label="Generated by" source="generatedByAlias" />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default LeadReportsListPage;
